import { render, staticRenderFns } from "./RecognitionsList.vue?vue&type=template&id=a27f2822"
import script from "./RecognitionsList.vue?vue&type=script&lang=js"
export * from "./RecognitionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports